import React from 'react'
import { Routes, Route } from "react-router-dom"
import Home from "../pages/Home"
import About from "../pages/About"
import CompareOneCar from "../pages/CompareOneCar"
import CompareTwoCars from "../pages/CompareTwoCars"
import LogIn from "../pages/LogIn"
import Quote from "../pages/Quote"
import Browse from "../pages/Browse"
import CarFocus from "../pages/CarFocus"
import Checkout from "../pages/Checkout"
import Contact from "../pages/Contact"
import NotFound from "../pages/NotFound"

const Routers = () => {
  return (
        <Routes>
            <Route path='/' element={ <Home/> }/>
            <Route path='/about' element={ <About/> }/>
            <Route path='/compareonecar' element={ <CompareOneCar/> }/>
            <Route path='/comparetwocars' element={ <CompareTwoCars/> }/>
            <Route path='/login' element={ <LogIn/> }/>
            <Route path='/getaquote' element={ <Quote/> }/>
            <Route path='/browse' element={ <Browse/> }/>
            <Route path='/browse/:id' element={ <CarFocus/> }/>
            <Route path='/checkout' element={ <Checkout/> }/>
            <Route path='/contact' element={ <Contact/> }/>
            <Route path='*' element={ <NotFound/> }/>
        </Routes>
  )
}

export default Routers
